import {Popup, List} from "semantic-ui-react";
import { useDiscountsContext } from "./Discount.Context";

export const SelectedConsultsTableIcon = ({ selectedConsults }) => {
      const {
        state: { availableConsults },
      } = useDiscountsContext();

      if(!selectedConsults || selectedConsults.length === 0) {
        return <p>No Consults Selected</p>;
      }
      const formattedConsults = selectedConsults.map((c) => {
        const consult = availableConsults.find((item) => item.c === c); 
        return consult ? `${consult.n} (${consult.c})` : c;
      }
      );
    return (
       <Popup
      content={
        <List>
          {formattedConsults.map((item) => (
            <List.Item className="border-b border-gray-300" key={item}>{item}</List.Item>
          ))}
        </List>
      }
      trigger={
        <p className="cursor-pointer text-blue-600 hover:underline">
          {selectedConsults.length} Consult{selectedConsults.length > 1 ? "s" : ""} Selected
        </p>
      }
    />
    );
}
